import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import "../../styleAllServices.css";
import seedImg from "../../../../assets/img/new-seedling-in-soil.png";
import aerationImg from "../../../../assets/img/lawn-aeration.jpg";

export default function Overseeding() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    let linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) { linkTag.setAttribute("href", canonicalUrl); }
    else {
      linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "canonical");
      linkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkTag);
    }
    document.title = "Lawn Overseeding Vancouver | Thicken & Repair Your Lawn | BUR-HAN";
    const desc = "Professional lawn overseeding in Vancouver. Thicken thin lawns, repair bare spots and improve grass variety with BUR-HAN's overseeding programs. Free quote: 604-983-2687";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) { metaDesc.setAttribute("content", desc); }
    else {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      metaDesc.setAttribute("content", desc);
      document.head.appendChild(metaDesc);
    }
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) { ogTitle.setAttribute("content", document.title); }
    else {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      ogTitle.setAttribute("content", document.title);
      document.head.appendChild(ogTitle);
    }
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) { ogDesc.setAttribute("content", desc); }
    else {
      ogDesc = document.createElement("meta");
      ogDesc.setAttribute("property", "og:description");
      ogDesc.setAttribute("content", desc);
      document.head.appendChild(ogDesc);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        <h1 data-aos="zoom-in">Lawn Overseeding Vancouver</h1>
      </div>
      <div className="serviceItemsMain">
        <h2 data-aos="fade-down">
          "Thicker, denser grass starts with the right seed at the right time."
        </h2>
        <hr />
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy" src={seedImg}
              alt="New grass seedlings germinating after lawn overseeding in Vancouver"
              title="Lawn Overseeding — New Grass Growth in Vancouver"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">What Is Lawn Overseeding?</h3>
            <p>
              Overseeding is the process of spreading new grass seed directly over your existing lawn — without tilling or removing turf. It is the most effective way to fill thin areas, repair bare patches, introduce improved grass varieties, and build the density that keeps weeds and moss from taking hold.
            </p>
            <p>
              BUR-HAN recommends overseeding every spring and fall. We use premium grass seed mixes selected for the Pacific Northwest climate — varieties that establish quickly, tolerate shade, and hold up well in Vancouver's wet winters and dry summers.
            </p>
          </div>
        </section>
        <section className="section-container">
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">Our Overseeding Process</h3>
            <ul>
              <li><strong>Timing:</strong> We overseed in early spring (March–April) or fall (September–October) — the two windows where soil temperature and moisture are ideal for seed germination in Vancouver.</li>
              <li><strong>Preparation:</strong> Overseeding works best after core aeration. Aeration opens holes in the soil, giving seed direct soil contact and improved germination rates.</li>
              <li><strong>Seed selection:</strong> We use professional-grade ryegrass, fescue, and bluegrass blends chosen for your lawn's specific light, drainage, and use conditions.</li>
              <li><strong>Application:</strong> Seed is spread evenly at the correct rate using calibrated spreaders to avoid gaps or over-application.</li>
              <li><strong>Watering guidance:</strong> We provide specific watering instructions to ensure successful germination in the weeks following treatment.</li>
            </ul>
          </div>
          <div className="image-container px-5" data-aos="fade-left">
            <img loading="lazy" src={aerationImg}
              alt="Lawn aeration preparing the ground for overseeding in Vancouver"
              title="Aeration Before Overseeding — BUR-HAN Vancouver"
            />
          </div>
        </section>

        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Residential Lawn Care Services</h2>
          <div className="lawnCareLinks-grid">
      <a href="/services/residential-lawn-care">
        <strong>Residential Lawn Care</strong>
        <span>All lawn care services</span>
      </a>
      <a href="/services/residential-lawn-care/liming">
        <strong>Lawn Liming</strong>
        <span>Soil pH correction</span>
      </a>
      <a href="/services/residential-lawn-care/moss-control">
        <strong>Moss Control</strong>
        <span>Treatment & prevention</span>
      </a>
      <a href="/services/residential-lawn-care/organic-weed-control">
        <strong>Organic Weed Control</strong>
        <span>Pesticide-free weed management</span>
      </a>
      <a href="/services/residential-lawn-care/topdressing">
        <strong>Topdressing</strong>
        <span>Compost & soil improvement</span>
      </a>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>Fill out our Get a Quote page and let BUR-HAN recommend the best overseeding program to restore density and health to your Vancouver lawn.</p>
              </div>
              <div className="col-md-6">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">Get A Quote</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
